import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.module.scss';

function Navbar(props) {
  const {
    active,
    html,
    shortcuts,
    showGlobal,
    theme,
  } = props;

  return (
    <nav
      className={classNames(
        'hfsh init',
        {
          active,
          'show-global': showGlobal,
          'show-shortcuts': shortcuts,
          [theme]: theme,
        },
      )}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  );
}

Navbar.propTypes = {
  active: PropTypes.bool.isRequired,
  html: PropTypes.string.isRequired,
  shortcuts: PropTypes.bool.isRequired,
  showGlobal: PropTypes.bool.isRequired,
  theme: PropTypes.string.isRequired,
};

Navbar.defaultProps = {};

const mapStateToProps = ({ navbar }) => ({
  active: navbar.active,
  shortcuts: navbar.shortcutsVisible,
  theme: navbar.theme,
});

export const HeaderNavbar = connect(mapStateToProps)(
  Navbar,
);
